import { render } from "./ExtratosForm.vue?vue&type=template&id=4b93d64c&scoped=true"
import script from "./ExtratosForm.vue?vue&type=script&lang=js"
export * from "./ExtratosForm.vue?vue&type=script&lang=js"

import "./ExtratosForm.vue?vue&type=style&index=0&id=4b93d64c&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b93d64c"]])

export default __exports__